<template>
  <div style="display: flex">
    <input type="text"
           ref="digitInput"
           class="form-control"
           :class="{'is-invalid': digitInput ==='' && highlightEmpty }"
           style="flex-grow: 1"
           v-for="(digitInput,index) in inputValues"
           :value="inputValues[index]"
           @keydown="keydownHandler(index, $event)"
           @focusin="focusHanlder(index)"
           @input="onInput(index, $event)"
    >
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "LetterInput",
  props: {
    digits: Number,
    value: String,
    highlightEmpty: Boolean
  },
  data: () => ({
    lastKey: null,
    inputValues: []
  }),
  created() {
    for (let i = 0; i < this.digits; i++) {
      this.inputValues.push('');
    }
  },
  watch: {
    value(val) {
      this.initialiseInput();
      let values = val.split('');
      values.forEach((value, index) => {
        if (index < this.inputValues.length) {
          Vue.set(this.inputValues, index, value);
        }
      });
      if (values.length > this.inputValues.length) {
        this.emitValue();
      }
    }
  },
  methods: {
    initialiseInput() {
      this.inputValues = [];
      for (let i = 0; i < this.digits; i++) {
        this.inputValues.push('');
      }
    },
    focusHanlder(index) {
      //select all in input
      this.$refs.digitInput[index].select()
    },
    keydownHandler(index, e) {

      this.lastKey = e.key
      if (e.key === 'Backspace') {
        if (index > 0) {
          this.$refs.digitInput[index - 1].focus();
        }
      }else if (this.lastKey === 'ArrowLeft') {
        if (index > 0) {
          this.$refs.digitInput[index - 1].focus();
          e.preventDefault();
        }
      } else if (this.lastKey === 'ArrowRight') {
        if (this.$refs.digitInput[index + 1]) {
          this.$refs.digitInput[index + 1].focus();
          e.preventDefault();
        }
      }else if (this.lastKey === 'ArrowUp') {
        if (index > 0) {
          this.$refs.digitInput[index - 1].focus();
          e.preventDefault();
        }
      } else if (this.lastKey === 'ArrowDown') {
        if (this.$refs.digitInput[index + 1]) {
          this.$refs.digitInput[index + 1].focus();
          e.preventDefault();
        }
      }
    },
    isComplete() {
      return this.inputValues.every((value) => value !== '');
    },

    onInput(index,event) {
      if (this.lastKey === 'Backspace') {
        this.inputValues[index] = ''
        this.$refs.digitInput[index].value = ''
      } else {
        this.inputValues[index] = event.data.replace(/\D/g, '');
        this.$refs.digitInput[index].value = event.data.replace(/\D/g, '');
        if (event.data.match(/[0-9]/i) && this.$refs.digitInput[index + 1]) {
          this.$refs.digitInput[index + 1].focus();
        } else {
          //this.$refs.digitInput[0].focus();
        }
      }
      this.emitOnComplete();
      this.emitValue();
    },
    emitOnComplete() {
      if (this.isComplete()) {
        this.$emit('onComplete');
      }
    },
    emitValue() {
      this.$emit('input', this.inputValues.join('').substring(0, this.digits));
    }
  }
}
</script>

<style scoped>

</style>